import { defineMessages } from 'react-intl-next';

export const messages: {
	filterByIcon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	more: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreAppsSearchTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contributor: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	type: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	filterByIcon: {
		id: 'search-filters.filter-by-icon',
		defaultMessage: 'Filter by icon',
		description: 'Label for filter by icon in Search filters row',
	},
	more: {
		id: 'search_filters.more',
		defaultMessage: 'more',
		description: 'Label to signify that a user can search for more connected apps',
	},
	moreAppsSearchTooltip: {
		id: 'search_filters.more-apps-search',
		defaultMessage: 'Open full page search for this term searching all apps',
		description: 'Label to signify that a user can search for more connected apps',
	},
	contributor: {
		id: 'search-filters.names.contributor',
		defaultMessage: 'Contributor',
		description: 'Label for filtering by contributor',
	},
	type: {
		id: 'search-filters.names.type',
		defaultMessage: 'Type',
		description: 'Label for filtering by type',
	},
});
